const t = "images-toggle.toggled", e = class e extends CustomEvent {
  constructor(o) {
    super(t, { detail: { isChecked: o }, bubbles: !0, composed: !0 });
  }
};
e.EVENT_NAME = t;
let s = e;
export {
  t as EVENT_NAME,
  s as default
};
//# sourceMappingURL=ImagesToggleEvent.js.map
